export default "__VITE_ASSET__DKvsZUwQ__"